import Input from "../Form/Input";
import * as S from "./styles";

const DateValidity = ({
  register,
  required = false,
  startRequired = false,
  finishRequired = false,
  startName = "start_at",
  finishName = "finish_at",
  startLabel = "Data de Início",
  finishLabel = "Data de Término",
}) => {
  return (
    <S.Wrapper>
      <Input
        {...register(startName)}
        type="date"
        label={startLabel}
        placeholder={startLabel}
        required={required || startRequired}
      />
      <Input
        {...register(finishName)}
        type="date"
        label={finishLabel}
        placeholder={finishLabel}
        required={required || finishRequired}
      />
    </S.Wrapper>
  );
};

export default DateValidity;
